










import {
  Vue,
  Component
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";


@Component({
  components: { Button }
})
export default class HelpIcon extends Vue {
  isMobile = false;
  visible = false;

  mounted () {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }

  toggle () {
    this.visible = !this.visible;
  }

  handleResize () {
    this.isMobile = window.innerWidth < 1100;
  }
}
